import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

function Journal() {
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();
  const [entries, setEntries] = useState([]);
  const [sortBy, setSortBy] = useState("newest");

  useEffect(() => {
    if (!token) {
      alert("Please log in to view your journal.");
      navigate("/login");
      return;
    }

    const saved = JSON.parse(localStorage.getItem("raptorid-journal")) || [];
    setEntries(saved);
  }, [token, navigate]);

  const deleteEntry = (index) => {
    const confirmed = window.confirm("Are you sure you want to delete this sighting?");
    if (!confirmed) return;

    const updated = [...entries];
    updated.splice(index, 1);
    localStorage.setItem("raptorid-journal", JSON.stringify(updated));
    setEntries(updated);
  };

  const clearJournal = () => {
    if (window.confirm("Are you sure you want to clear all your sightings?")) {
      localStorage.removeItem("raptorid-journal");
      setEntries([]);
    }
  };

  const sortedEntries = [...entries].sort((a, b) => {
    if (sortBy === "newest") return new Date(b.date) - new Date(a.date);
    if (sortBy === "oldest") return new Date(a.date) - new Date(b.date);
    if (sortBy === "az") return a.name.localeCompare(b.name);
    if (sortBy === "za") return b.name.localeCompare(a.name);
    if (sortBy === "location") return a.location.localeCompare(b.location);
    return 0;
  });

  return (
    <div className="container">
      <h2>My Bird Journal</h2>

      {entries.length === 0 ? (
        <p>No sightings saved yet.</p>
      ) : (
        <>
          <div style={{ marginBottom: "20px" }}>
            <label>Sort by: </label>
            <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
              <option value="newest">Date (Newest First)</option>
              <option value="oldest">Date (Oldest First)</option>
              <option value="az">Species (A-Z)</option>
              <option value="za">Species (Z-A)</option>
              <option value="location">By Location</option>
            </select>
          </div>

          {sortedEntries.map((entry, i) => (
            <div
              key={i}
              className="journal-card"
              style={{
                marginBottom: "20px",
                paddingBottom: "10px",
                borderBottom: "1px solid #ccc",
              }}
            >
              <h3>{entry.name}</h3>
              <p><strong>Description:</strong> {entry.description || "No description provided."}</p>
              <p>
               <strong>Location:</strong>{" "}
               {entry.location ? entry.location : <em>Not specified</em>}
              </p>

              <p>
                <strong>Why:</strong> {entry.why}
              </p>
              <p>
                <strong>Confidence:</strong> {entry.confidence}
              </p>
              <p>
                <em>{entry.date}</em>
              </p>
              <button onClick={() => deleteEntry(i)}>Delete This Sighting</button>
            </div>
          ))}
          <button onClick={clearJournal} style={{ marginTop: "20px" }}>
            Clear All Sightings
          </button>
        </>
      )}

      <footer style={{ textAlign: "center", marginTop: "40px", fontSize: "14px", color: "#444" }}>
        Made with 🦅 and 🌿 by Louise
      </footer>

    </div>
  );
}


export default Journal;
